import { Button, styled, Box, IconButton, Typography } from "@mui/material";

export const TypeButton = styled(Button)<any>(({ theme, variant }) => ({
  backgroundColor: variant == "contained" ? "#E1FFA2" : "transparent",
  fontWeight: 500,
  fontSize: "15px",
  lineHeight: "18.5px",
  // padding: "0.2rem 2.5rem",
  marginRight: "1rem",
  marginTop: "0.5rem",
  height: "56px",
  width: "192px",
  color: "#000",
  border: `1px solid #f0f0f0`,
  // filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1))',
  // fontFamily: ['Inter', 'sans-serif'].join(','),
  "&.MuiButton-containedPrimary": {
    border: `1px solid ${theme.palette.primary}`,
  },
  "&:hover": {
    backgroundColor:  variant == "contained" ? "#E1FFA2":"transparent",
    
  },
  // '& .selected.svg > path': {
  //   fill: '#000',
  // },
  "& img": {
    paddingRight: "8px",
    height: "24px",
    width: "24px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "0.3rem 2.2rem",
    fontSize: 14,
    width: "auto",
  },
}));

export const ImageBox = styled(Box, { shouldForwardProp: (prop: any) => prop })(
  ({ height, width, theme }: any) => ({
    background: "#FFF",
    border: `1px solid ${theme.palette.primary.main}`,
    height: height,
    width: width,
    borderRadius: "6px",
    position: "relative",
    // margin: '0.5rem 1.5rem 0rem 0rem',
  })
);

export const CloseButton = styled(IconButton)(() => ({
  position: "absolute",
  top: "-1rem",
  right: "-1.2rem",
  // zIndex: 1,
}));

export const Title = styled(Typography)<any>(({ theme, variant }) => ({
  color: "#323232",
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "35px",
  fontFamily: "Inter",
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
  },
}));

export const SubTitle = styled(Typography)<any>(({ theme, variant }) => ({
  color: "#A2A2A2",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  fontFamily: "Inter",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
    lineHeight: "20px",
  },
}));

export const Label = styled(Typography)<any>(({ theme, variant }) => ({
  color: "#323232",
  fontWeight: 600,
  fontSize: "18px",
  lineHeight: "31px",
  fontFamily: "Inter",
  textAlign: "left",

  [theme.breakpoints.down("md")]: {
    fontSize: "15px",
    lineHeight: "26px",
  },
}));
